// extracted by mini-css-extract-plugin
export default {"mainNav":"_navbarUser_mainNav__DWn2l","link":"_navbarUser_link__g7Oms","user":"_navbarUser_user__gfr8h"};